import Swiper from 'swiper';
import { Autoplay, Navigation } from 'swiper/modules';
import { checkIfElementExists } from "../helper/dom-helper";
import 'swiper/css';

export async function initializeTipsAndAdviceSlider() {
    const brekzTipsAndAdviceSliderQuerySelector = '.brekz-tips-and-advice-slider';

    if (! await checkIfElementExists(brekzTipsAndAdviceSliderQuerySelector)) {
        // We are probably on another page, just don't do anything

        return;
    }

    new Swiper(brekzTipsAndAdviceSliderQuerySelector, {
        modules: [Navigation, Autoplay],
        loop: true,
        spaceBetween: 10,
        speed: 1000,
        autoplay: {
            delay: 4000,
            disableOnInteraction: true,
        },
        navigation: {
            nextEl: `${brekzTipsAndAdviceSliderQuerySelector} > .swiper-button-next`,
            prevEl: `${brekzTipsAndAdviceSliderQuerySelector} > .swiper-button-prev`,
        },
        slidesPerView: 1,
        slidesPerGroup: 1,
        rtl: true,
        on: {
            init: (swiper) => {
                swiper.el.classList.add('swiper-initialized');
            },
        },
    });
}
